// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Cuttable/Cuttable.less
// module id = 197
// module chunks = 2